import { api_host,api_auth} from '../../common/globals/constants';

export const getThresholdNotification = (objective, token) => 
fetch(api_host+`/reporte/general/objetivos/${objective}/alertas_umbral/?token=${token}`)
.then(response => response.json())